import compareRowDateTime, { shouldUseDraftsMeaningfulSaveTimeSort } from "./compareRowDateTime";
import type { MailFolderTableQuery, TableView } from "owa-mail-list-store";
import { MailRowDataPropertyGetter, type SortColumn } from "owa-mail-list-store";
import { ASCENDING_SORT_DIR } from "owa-mail-list-store/lib/utils/sort/mailSortHelper";

export default function isMessageListOutOfOrder(tableView: TableView, insertIndex: number): boolean {
    const mailTableQuery = tableView.tableQuery as MailFolderTableQuery;
    
    // We only have support to evaluate sort order for DateTime sort on the client side so we will assume the ML is in order for other sorts.
    // If the folder is empty or there are no additional rows below the last inserted row, then we return false.
    if (mailTableQuery.sortBy?.sortColumn !== 1 ||
        tableView.rowKeys.length <= insertIndex ||
        tableView.rowKeys.length === 0) {
        return false;
    }
    
    const rowKeyAtLastIndexInserted = tableView.rowKeys[insertIndex - 1];
    const rowKeyAtInsertIndex = tableView.rowKeys[insertIndex];
    let rowDateTimeComparison = 0;
    
    // When the table is ordered by the Drafts meaningful-save-time sort key, the comparator keys
    // the reference row by that key, so the row being compared against it must be keyed the same
    // way (LastMeaningfulDraftSaveTime primary, LastModifiedTime tie-breaker) to stay symmetric.
    const useDraftsMeaningfulSaveTime = shouldUseDraftsMeaningfulSaveTimeSort(tableView);
    
    let lastDeliveryOrRenewTimeStampRowAtInsertIndex;
    let lastDeliveryTimeStampRowAtInsertIndex;
    
    if (useDraftsMeaningfulSaveTime) {
        // The Drafts sort key has no delivery component: LastModifiedTime is the tie-breaker the
        // comparator reads out of the delivery slot, so both arguments carry the same value.
        const lastModifiedTimeStampRowAtInsertIndex = MailRowDataPropertyGetter.getLastModifiedTimeStamp(rowKeyAtInsertIndex, tableView);
        lastDeliveryOrRenewTimeStampRowAtInsertIndex = lastModifiedTimeStampRowAtInsertIndex;
        lastDeliveryTimeStampRowAtInsertIndex = lastModifiedTimeStampRowAtInsertIndex;
    }
    else {
        lastDeliveryOrRenewTimeStampRowAtInsertIndex =
            MailRowDataPropertyGetter.getLastDeliveryOrRenewTimeStamp(rowKeyAtInsertIndex, tableView);
        lastDeliveryTimeStampRowAtInsertIndex = MailRowDataPropertyGetter.getLastDeliveryTimeStamp(rowKeyAtInsertIndex, tableView);
    }
    
    rowDateTimeComparison = compareRowDateTime(lastDeliveryOrRenewTimeStampRowAtInsertIndex, lastDeliveryTimeStampRowAtInsertIndex, rowKeyAtLastIndexInserted, tableView, useDraftsMeaningfulSaveTime
        ? MailRowDataPropertyGetter.getLastMeaningfulDraftSaveTimeStamp(rowKeyAtInsertIndex, tableView)
        : undefined);
    
    return mailTableQuery.sortBy.sortDirection === ASCENDING_SORT_DIR
        ? rowDateTimeComparison > 0
        : rowDateTimeComparison < 0;
}
